import { z } from "zod";

export const priceSchema = z.object({
  currency: z.string(),
  amount: z.number(),
  region: z.string(),
  id: z.string().nullable(),
  hotmart_offer_code: z.string().optional().nullable(),
});

export type Price = z.infer<typeof priceSchema>;
